







import Vue from 'vue'
import tabLabel from '@/components/common/click/tab/tab-label.vue'
import style from './style.module.scss'

export default Vue.extend({
    name: 'tab-switcher',
    components: {
        tabLabel
    },
    props: {

    },
    data() {
        return {
            style: style,
            activeTab: 'delivery'
        }
    },
    methods: {
        activate(tabName: string): void {
            this.activeTab = tabName;
            this.$emit('switch', tabName);
        }
    }
})
